export default __webpack_public_path__ + "static/media/265.1b2471f9.png";